webpackJsonp([90249615434571],{

/***/ 356:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>\"People who document histories of special people, places and events are selfless in the same way that are those who plant trees. The result is valued more by each future generation. Thank you for doing this.\"</p>","frontmatter":{"path":"/content/future-generations","year":"1990-1999","title":"Future Generations","image":null,"imagetitle":null,"author":"Dean Williams","publication":null}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---content-future-generations-89c9eb1c92869bfa0a5c.js